import { Box, CircularProgress } from '@chakra-ui/react'
import React from 'react'

export const Loader = (color?: { color?: string }) => (
  <Box alignItems="center" display="flex" flex="1" height="100%" justifyContent="center">
    <CircularProgress isIndeterminate style={color} />
  </Box>
)
